import * as React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "../atoms/Button";
import { Box } from "@mui/material";

export default function FavInfoPopover() {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    event.preventDefault(); 
    event.stopPropagation();
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        handleClick={handleClick}
        type="icon"
        iconProps={{
          sx: { fontSize: "18px" },
          baseClassName: "fa-regular",
          className: "fa-info-circle",
        }}
        fitIcon
      />
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box sx={{ p: 2 }}>
          <Typography typography="subtitle1" fontWeight="bold">
            Favorite
          </Typography>
          <Typography typography="body2">
            Flag items as favorites to pin them to the top of the list.
          </Typography>
        </Box>
      </Popover>
    </>
  );
}